import { useEffect } from "react";
import { useLogout } from "../../hooks/useLogout";

const Signout = () => {
  const { logout } = useLogout();

  useEffect(() => {
    logout();
  }, []);

  return null;
};

export default Signout;
